/* eslint-disable react/prop-types */
import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  SvgIcon,
  Block,
} from '@material-ui/core';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { Search as SearchIcon } from 'react-feather';
import { Link as RouterLink, useNavigate } from 'react-router-dom';


const AddNewExtraChargesToolbar = ({
  resetData,
  addNewExtraCharge,
  handleChangeDeliveryType,
  selectvalue,
  selectvalues,
  handleChangeSettlementSno,
  customers,
  handleSearchText,
  clickToSearch,
  toggleButton
}) => {
  const navigate = useNavigate();
  const [amount, setAmount] = useState('');
  const [comment, setComments] = useState('');
  const [settlementSno, setSettlementSno] = useState([]);
  const [searchtext, setSearchtext] = useState('');
  const [clientname, setClientName] = useState('');


  const handleAddSettlementAmount = (event) => {
    const regularExpression = /^\d*\.?\d*$/;
    if (
      event.target.value === '' ||
      regularExpression.test(event.target.value)
    ) {
      setAmount(event.target.value);
    }
  };

  const handleComments = (event) => {
    setComments(event.target.value);
  }

  useEffect(() => {
    if (resetData) {
      setAmount('');
      setComments('');
    }
  }, [resetData]);

  useEffect(() => {
    if (selectvalue == 7 && clientname == "Move my stuff - STANDARD") {
      setAmount(3000);
    } else {
      setAmount('');
    }
  }, [selectvalue]);

  useEffect(() => {
    if (customers) {
      setSettlementSno(customers && customers);
    } else {
      setSettlementSno([]);
    }
  }, [customers]);

  const handleSearchInvNo = (inv) => {
    setSearchtext(inv);
    handleSearchText(inv);
  };


  useEffect(() => {
    const clientid = localStorage.getItem('tranuserid');
    if (!clientid || clientid === '' || clientid === 'null') {
      navigate('/login', { replace: true });
    }
    setClientName(clientid);
  }, []);


  return (
    <Box>
      <Box sx={{ mt: 0 }}>
        <Card>
          <CardContent>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={3}>
                <Grid item xs={3} style={{ display: 'flex', padding: '13px 0px 7px 24px' }}>
                  <h2>Settlement No</h2>
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={3}>
                <Grid item xs={3} style={{ display: 'flex' }}>
                  <TextField
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon fontSize="small" color="action">
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    sx={{ width: '50ch' }}
                    placeholder="Search "
                    onChange={(e) => handleSearchInvNo(e.target.value)}
                    onKeyPress={(e) => clickToSearch(e, '1')}
                  />
                  <Button
                    variant="contained"
                    onClick={() => clickToSearch(searchtext, '2')}
                  >
                    Search
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </Box>
      <Accordion>
        <AccordionSummary
          aria-controls="panel1a-content"
          id="panel1a-header"
          aria-expanded="false"
        >
          <Box style={{ width: "100%", textAlign: "right" }}>
            <Button
              variant="contained"
              color="primary"
              size="large"
            >
              Add Extra Charges
            </Button>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <Box sx={{ mt: 0 }}>

              <Card>
                <CardContent>
                  <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={3}>
                      <Grid item xs={3} style={{ display: 'flex', padding: '13px 0px 7px 24px' }}>
                        <h2>Add Extra Charges</h2>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={3}>
                      <Grid item xs={2} style={{ display: 'grid' }}>
                        <FormControl fullWidth>
                          <InputLabel
                            id="demo-simple-select-label"
                          >
                            Settlement no
                          </InputLabel>

                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectvalues}
                            label="Settlement No"
                            onChange={handleChangeSettlementSno}
                          >
                            {settlementSno && settlementSno.map((item) =>
                              <MenuItem value={item.t1}>{item.t1}</MenuItem>
                            )}
                          </Select>
                        </FormControl>


                      </Grid>

                      <Grid item xs={2} style={{ display: 'grid' }}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">Delivery Type</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Delivery Type"
                            value={selectvalue}
                            onChange={handleChangeDeliveryType}
                          >
                            {/* <MenuItem value={0}>Truck Hire</MenuItem>
                            <MenuItem value={1}>Labour Hire</MenuItem>
                            <MenuItem value={2}>Others</MenuItem> */}
                            {/* <MenuItem value={0}>Truck Hire(4T)</MenuItem>
                            <MenuItem value={1}>Truck Hire(6T)</MenuItem>
                            <MenuItem value={2}>Truck Hire(10T)</MenuItem>
                            <MenuItem value={3}>Truck Hire(Van)</MenuItem>
                            <MenuItem value={4}>Labour Hire</MenuItem> */}
                            <MenuItem value={5}>Other</MenuItem>
                            <MenuItem value={6}>Cancelling</MenuItem>
                            <MenuItem value={7}>Linehaul Fee</MenuItem>

                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={3} style={{ display: 'flex' }}>
                        <TextField
                          fullWidth
                          id="outlined-multiline-static"
                          label="Amount"
                          disabled={selectvalue == 7 && clientname == "Move my stuff - STANDARD" ? true : false}
                          multiline
                          rows={1}
                          value={amount}
                          columns={20}
                          onChange={handleAddSettlementAmount}

                        />
                      </Grid>

                      <Grid item xs={3} style={{ display: 'grid' }}>
                        <TextField
                          fullWidth
                          id="outlined-multiline-static"
                          label="Comment"
                          multiline
                          rows={1}
                          value={comment}
                          columns={20}
                          onChange={handleComments}
                        />
                      </Grid>
                      <Grid item xs={2}>
                        {toggleButton !== true ?
                          <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            onClick={() => {
                              addNewExtraCharge(amount, comment);
                            }}
                          >
                            Add
                          </Button>
                          : <Button
                            variant="contained"
                            color="primary"
                            size="large"
                          >
                            Wait..
                          </Button>
                        }
                      </Grid>
                    </Grid>
                  </Box>
                </CardContent>
              </Card>
            </Box>
          </Typography>
        </AccordionDetails>
      </Accordion>

    </Box >
  );
};

export default AddNewExtraChargesToolbar;